import { onMounted, onUnmounted } from "#imports";
export var ClickAwayMode = /* @__PURE__ */ ((ClickAwayMode2) => {
  ClickAwayMode2["External"] = "external";
  ClickAwayMode2["Equal"] = "equal";
  ClickAwayMode2["Focusout"] = "focusout";
  ClickAwayMode2["Any"] = "any";
  return ClickAwayMode2;
})(ClickAwayMode || {});
export function useClickAway(el, handler, enabled, mode = "external" /* External */) {
  const clickAwayEvent = (event) => {
    if (!enabled.value) return;
    let clicked = false;
    switch (mode) {
      case "any" /* Any */:
        clicked = true;
        break;
      case "equal" /* Equal */:
        if (el.value === event.target) {
          clicked = true;
        }
        break;
      case "external" /* External */:
        if (!(el.value === event.target || el.value.contains(event.target))) {
          clicked = true;
        }
        break;
      case "focusout" /* Focusout */:
        if (!(el.value === event.relatedTarget || el.value.contains(event.relatedTarget))) {
          clicked = true;
        }
        break;
    }
    if (clicked) handler();
  };
  return {
    clickAwayEvent
  };
}
export function useClickAwayListener(el, handler, enabled, mode = "external" /* External */) {
  const { clickAwayEvent } = useClickAway(el, handler, enabled, mode);
  onMounted(() => {
    document.addEventListener("click", clickAwayEvent);
  });
  onUnmounted(() => {
    document.removeEventListener("click", clickAwayEvent);
  });
}
